import { lazy } from 'react'

export const DateOfBirth = lazy(() => import('./DateOfBirth'))
